module.exports = __webpack_public_path__ + "macroScenario.7f2c30f6448db5ad2999f0ffd53a2a04.png";